export function getBlackboxList(data) {
    let { getBlackboxListRequest, getBlackboxListError, getBlackboxListResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'blackbox/blackbox_list',
        this.createBundle('blackbox/blackbox_list', { data: data }, this.GET, getBlackboxListRequest, getBlackboxListResult, getBlackboxListError)
    )
}
